import {NotImplementedError} from '../NotImplemented'

export async function setStoryPasteboard(
  _imageBase64: string,
  _contentUrl: string,
  _expirationMs: number,
): Promise<void> {
  throw new NotImplementedError({
    contentUrl: _contentUrl,
    expirationMs: _expirationMs,
  })
}
